// src/api/services/translationService.ts

import apiClient from "api/client/axios.client";
import type { FrontMessageTranslationDto, TranslationMap } from "types/translation.types";
 

export const translationService = {
  getByKeys: async (languageId: number | string, keys: number[]): Promise<TranslationMap> => {
    // اگر کلیدی پاس داده نشد، الکی ریکوئست نزنیم
    if (!keys || keys.length === 0) {
      return {};
    }

    // ساخت کوئری OData
    // $select: فقط فیلدهای مورد نیاز را می‌گیرد
    // $filter: بر اساس زبان و لیست کلیدها فیلتر می‌کند
    const keysString = keys.join(",");
    const query = `?$select=MessageId,TranslatedText,LanguageId&$filter=LanguageId eq ${languageId} and MessageId in (${keysString})`;

    // در OData معمولا دیتای آرایه‌ای داخل فیلد value قرار دارد
    const response = await apiClient.get<{ value: FrontMessageTranslationDto[] }>(
      `/Setting/odata/FrontMessageTranslationOData${query}`
    );

    const map: TranslationMap = {};
    
    // مپ کردن دیتای پاسکال کیس (PascalCase) به ساختار مورد نیاز مپ
    (response.data.value ?? []).forEach((item) => {
      map[item.MessageId] = item.TranslatedText;
    });

    return map;
  },
};